import {createTheme} from "@mui/material";

declare module "@mui/material/styles" {
	// allow configuration using `createTheme`
	// eslint-disable-next-line @typescript-eslint/naming-convention
	interface ThemeOptions {
		[key: string]: unknown;
	}
}

const themeObject = {
	primary: "#03122B",
	secondary: "#00B8FF",
	background: {
		primary: "#190F52",
		primaryHover: "#160d49",
	},
	title_font: '"Qatar2022", sans-serif',
	base_font: '"Graphik", sans-serif',
	text: {
		primary: "#ffffff",
		secondary: "#03122B",
		tertiary: "#A5ACBB",
		active: "#F43056",
	},
	global: {
		header_background: "#ffffff",
		header_hover_color: "#045694",
		footer_background: "#020F2A",
	},
	button: {
		primary: {
			background: "#550065",
			hover: {
				background: "#873EB4",
				boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
			},
			disabled: "#E5E5E5",
		},
		secondary: {
			color: "#550065",
			borderColor: "#550065",
		},
		cancel: {
			background: "#FF004C",
			hover: {
				background: "#FF004C",
				boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
			},
		},
	},
};

export const theme = createTheme(themeObject);
type ThemeInterface = typeof themeObject;

declare module "styled-components" {
	// Allows change type of  theme to avoid any
	/* eslint-disable @typescript-eslint/no-empty-interface */

	// eslint-disable-next-line @typescript-eslint/naming-convention
	export interface DefaultTheme extends ThemeInterface {}
}
